import { MealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import { SemanticUiColorsEnum } from 'Common/Constants/SemanticUiColors';

export const ItemFilterOptions = [
  {
    text: 'Breakfast',
    value: MealTypesEnum.Breakfast,
  },
  {
    text: 'Lunch',
    value: MealTypesEnum.Lunch,
  },
  {
    text: 'Supper',
    value: MealTypesEnum.Supper,
  },
  {
    text: 'Other',
    value: MealTypesEnum.Other,
  },
];

export const ColorSetupTypeEnum = {
  NutritionCode: 0,
  Category: 1,
};

export const CategoryEnum = {
  Planned: 4,
};

export const ColorTypeFilterOptions = [
  {
    text: 'Nutrition Code',
    value: ColorSetupTypeEnum.NutritionCode,
  },
  {
    text: 'Category',
    value: ColorSetupTypeEnum.Category,
  },
];

export const DefaultColors = {
  '1': SemanticUiColorsEnum.ORANGE,
  RS: SemanticUiColorsEnum.ORANGE,
  SM: SemanticUiColorsEnum.ORANGE,
  '2': SemanticUiColorsEnum.BLUE,
  X: SemanticUiColorsEnum.BLUE,
};

export const DefaultCategoryColors = {
  [CategoryEnum.Planned]: '#DDDA0DD',
};



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/helpers/constants.js